module.exports = __webpack_public_path__ + "static/media/cart-new.4061279d.png";